var map = {
	"./kittens/kitten-1280-01.webp": 1085,
	"./kittens/kitten-1280-02.webp": 7821,
	"./kittens/kitten-1280-03.webp": 9411,
	"./kittens/kitten-1280-04.webp": 5358,
	"./kittens/kitten-1280-05.webp": 6523,
	"./kittens/kitten-1280-06.webp": 2148,
	"./kittens/kitten-1280-07.webp": 828,
	"./kittens/kitten-1280-08.webp": 9282,
	"./kittens/kitten-1280-09.webp": 3469,
	"./kittens/kitten-1280-10.webp": 5609,
	"./kittens/kitten-320-01.webp": 8872,
	"./kittens/kitten-320-02.webp": 8313,
	"./kittens/kitten-320-03.webp": 4782,
	"./kittens/kitten-320-04.webp": 862,
	"./kittens/kitten-320-05.webp": 6102,
	"./kittens/kitten-320-06.webp": 3517,
	"./kittens/kitten-320-07.webp": 7473,
	"./kittens/kitten-320-08.webp": 7240,
	"./kittens/kitten-320-09.webp": 4678,
	"./kittens/kitten-320-10.webp": 5387,
	"./kittens/kitten-640-01.webp": 3676,
	"./kittens/kitten-640-02.webp": 9775,
	"./kittens/kitten-640-03.webp": 2127,
	"./kittens/kitten-640-04.webp": 4938,
	"./kittens/kitten-640-05.webp": 8020,
	"./kittens/kitten-640-06.webp": 5606,
	"./kittens/kitten-640-07.webp": 3265,
	"./kittens/kitten-640-08.webp": 1681,
	"./kittens/kitten-640-09.webp": 2128,
	"./kittens/kitten-640-10.webp": 4667,
	"./kittens/kitten-960-01.webp": 1317,
	"./kittens/kitten-960-02.webp": 8247,
	"./kittens/kitten-960-03.webp": 8446,
	"./kittens/kitten-960-04.webp": 9265,
	"./kittens/kitten-960-05.webp": 646,
	"./kittens/kitten-960-06.webp": 5920,
	"./kittens/kitten-960-07.webp": 1150,
	"./kittens/kitten-960-08.webp": 5887,
	"./kittens/kitten-960-09.webp": 5094,
	"./kittens/kitten-960-10.webp": 253
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5336;